module.exports = __webpack_public_path__ + "img/footer-logo.9820d7a3.jpg";